export function formatProfileTime(timestamp: string | Date): string {
  return new Date(timestamp).toLocaleTimeString("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

interface ProfileChartGeometry {
  left: number;
  width: number;
  viewBoxWidth: number;
  plotLeft: number;
  plotRight: number;
}

export function profileDistanceAtPointer(
  clientX: number,
  chart: ProfileChartGeometry,
  maxDistance: number,
): number {
  if (chart.width <= 0) {
    return 0;
  }

  const pointerX = ((clientX - chart.left) / chart.width) * chart.viewBoxWidth;
  const plotWidth = chart.viewBoxWidth - chart.plotLeft - chart.plotRight;
  const ratio = Math.min(Math.max((pointerX - chart.plotLeft) / plotWidth, 0), 1);

  return ratio * maxDistance;
}
